<template class="achtergrond-vvs-licht-blauw">
  <v-app>
    <router-view/>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  components: {},
}
</script>
<style>
</style>
